<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="工单列表"
      id-key="UserId"
      :data="data"
     
      @close-saved="$emit('close-saved')"
    >
      <list
        row-key="UserId"
        ref="list"
        unit="工单列表"
        :page="page"
        show-query
        :query-params="params"
        :get-data-func="api.getDocOperationList"
        :show-checkbox="type"
        @check-change="checkChange"
        :resetDataFunc="resetData"
      @reset="$refs.picker.clear()"

      >
        <template slot="query">
          <el-form-item el-form-item label="单据日期">
            <range-picker
              ref="picker"
              @change="(x) => {params.DocDateStart=x.Start;params.DocDateEnd=x.End}"
            />
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input
              clearable
              v-model="params.ProductName"
              placeholder="请输入产品名称"
            />
          </el-form-item>
          <el-form-item label="工单类型">
            <el-select clearable v-model="params.Stage">
              <el-option label="注塑" value="0"></el-option>
              <el-option label="特殊" value="1"></el-option>
              <el-option label="配件" value="2"></el-option>
              <el-option label="装配" value="3"></el-option>
              <el-option label="组合" value="4"></el-option>
              <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
            </el-select>
            <!-- <el-select clearable v-model="params.ProcessStage">
              <el-option
                v-for="item in ProductionPhaseOptions"
                :key="item.DictionaryId"
                :label="item.ItemText"
                :value="item.ItemValue"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="模具名称">
            <el-input
              clearable
              v-model="params.MouldName"
              placeholder="请输入模具名称"
            />
          </el-form-item>
        </template>
        <template slot="table">
          <el-table-column
            prop="DocDate"
            label="单据日期"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="WorkDocNo"
            label="工单号"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ProductName"
            label="存货名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="MouldName"
            label="模具名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="PropertyName"
            label="属性"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ColorName"
            label="颜色"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="Quantity"
            label="数量"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="StageName"
            label="加工阶段"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ProgrammeName"
            label="工艺方案"
            min-width="120"
          ></el-table-column>
           <el-table-column v-if="!false" label="操作" fixed="right" align="center" width="80">
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="$permission.canWrite()"
                type="text"
                @click="select(row, $index)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </template>
      </list>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";


export default {
  mixins: [editDialogMixin, listMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    type: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      params: {
        DocDateStart: '',
        DocDateEnd: "",
        ProductName: "",
        MouldName: "",
        Stage: "0",
        IsSearchMaterial: true,
        WorkDocProperty: 0,
        IsMerge: false,
        IsSplit: false,
      },
      data: {},
      api: require('@/api/production/workDoc').default,
      commonApi: require("@/api/common/common").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      ProductionPhaseOptions: [],
      arr: [],
      machiningStageList: [],
    };
  },
  created() {
    this.commonApi.getDictionaryList().then((res) => {
      this.ProductionPhaseOptions = res.Data.filter((v) => {
        return v.Code === "ProcessStage";
      });
    });
    this.machiningStageApi.list({ Status: 1 }).then((res) => {
      this.machiningStageList = res.Data;
    });
  },
  methods: {
    toDateStringByFormat(value, format) {
      if (!value) return "";
      let m = this.$moment(value);
      if (!m.isValid()) {
        return "";
      }
      return m.format(format);
    },
    resetData(data){
      data.forEach(item => {
        item.DocDate = this.toDateStringByFormat(item.DocDate, "YYYY-MM-DD")
      })
      return data
    },
    del() {},
    checkChange(list){
      this.arr = list;
    },
    save(){
      this.$emit('saved', this.arr)
      this.close();
    },
    select(row, index){
      let arr = [];
      arr.push(row);
      this.arr = arr;
      this.$emit('saved', this.arr)
      this.close();
    }
  },
};
</script>
